import { render } from "./company_bank_account_form.html?vue&type=template&id=23ff2be4&external"
import script from "./company_bank_account_form.js?vue&type=script&lang=js&external"
export * from "./company_bank_account_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__